import Tooltip from "@codegouvfr/react-dsfr/Tooltip";
import React, { useEffect, useState } from 'react';
import { FaCircleInfo } from "react-icons/fa6";
import { useCheckFormSchema } from './hooks/use-check-form-schema.hook';
import { useFormFieldParams } from './hooks/use-form-field-params.hook';

export const PrefixedTextField = ({
                                    name,
                                    prefix,
                                    maxDigits,
                                    title,
                                    value: inputValue,
                                    placeholder,
                                    className,
                                    onChange,
                                    tooltip,
                                  }: PrefixedTextFieldProps) => {
  useCheckFormSchema({ name });

  const { inputProps, error, isRequired, isReadonly } = useFormFieldParams({ name });

  const [value, setValue] = useState<string>();

  useEffect(() => {
    setValue(inputValue?.slice(prefix.length)
      .replace(/\D/g, '')
      .slice(0, maxDigits) ?? '',
    );
  }, [inputValue]);

  const prefixLength = prefix.length;

  const handleChange = (ev) => {
    const newValue: string = ev.target.value;

    const finalValue = newValue
      .slice(prefix.length)
      .replace(/\D/g, '')
      .slice(0, maxDigits);

    setValue(finalValue);
    // on remonte l'event de changement de valeur au parent
    onChange?.(prefix + finalValue);
  };

  const handleKeyDown = (ev) => {
    const cursorPosition = ev.target.selectionStart;
    if (cursorPosition <= prefixLength) {
      if (ev.key === 'Backspace' || ev.key === 'Delete' || ev.key === 'ArrowLeft') {
        ev.preventDefault();
      }
    }
  };

  const handleFocus = (ev) => {
    setTimeout(() => {
      const position = prefixLength + value.length;
      ev.target.setSelectionRange(position, position);
    }, 0);
  };

  return (
    <div className={'form-field ' + (className ?? '')}>

      {(title) && (
        <label className={'flex gap-1'} htmlFor={name}>
          {title} {isRequired && <label>*</label>}
          {(tooltip) && (
            <Tooltip title={tooltip!} kind="hover">
              <FaCircleInfo className={'color-primary'} />
            </Tooltip>
          )}
        </label>
      )}

      {(error?.message) && (
        <span className={'error-message'}>{error?.message}</span>
      )}

      <div className={'relative'}>
        <input
          {...inputProps}
          className={'form-field-input'}
          placeholder={!isReadonly ? (placeholder ?? '') : ''}
          type="text"
          autoComplete="off"
          style={{
            color: 'transparent', outline: 'none', caretColor: 'black', letterSpacing: 'normal',
            backgroundColor: isReadonly ? '#eaeaea' : '',
          }}
          value={prefix + value}
          onChange={(ev) => {
            handleChange(ev);
            inputProps.onChange(ev).then();
          }}
          onFocus={handleFocus}
          onKeyDown={handleKeyDown}
          readOnly={isReadonly ?? false}
          disabled={isReadonly ?? false}
        />
        <div
          className={'absolute top-0 left-0 bottom-O right-0 px-4 py-[12.5px] flex items-center pointer-events-none'}>
          <span
            className={`${isReadonly ? 'text-(--text-disabled-grey)' : 'text-gray-400'} text-[15px]`}>{prefix}</span>
          <span
            className={`${isReadonly ? 'text-(--text-disabled-grey)' : 'text-black'} ml-0.5 text-[15px]`}>{value}</span>
        </div>
      </div>
    </div>
  );
};

export interface PrefixedTextFieldProps {
  name: string;
  title?: string;
  prefix: string;
  maxDigits: number;
  placeholder?: any;
  value?: string | null;
  onChange?: (val: string) => void;
  className?: string;
  tooltip?: string;
}